/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CancellationReason } from './cancellationReason';
import { Company } from './company';
import { PreviousProduct } from './previousProduct';

/**
 * Contract of previous insurance.   (german: Vorversicherung Vertrag)   (bipro-vertrag::Vertrag)
 */
export interface PreviousContract {
  company?: Company;
  /**
   * Contract number of the previous insurance. (german: Vertragsnummer)
   */
  contractNumber?: string;
  cancellationReason?: CancellationReason;
  /**
   * One or more insurance products for a concrete insurance sector.
   */
  products?: Array<PreviousProduct>;
}
export namespace PreviousContract {}
